import IValidation from './IValidation';

export default class Digit implements IValidation {
    public valid(value: string) {
        return !!value.match(/[0-9]/g);
    }

    public get message() {
        return 'Must contain a digit';
    }
}
